import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mediaStatus' })
export class MediaStatusPipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    let result = null;
    switch (obj) {
      case 'ATTACHED':
        result = '장착';
        break;
      case 'DETACHED':
        result = '탈착';
        break;
    }
    return result;
  }
}
